// src/components/NewClientModal.js
import React from 'react';
import PropTypes from 'prop-types';
import { formatCUIL } from '../../utils/documentFormatter';
import { getInitials } from '../../utils/avatar';

const NewClientModal = ({ client, onConfirm, onClose, loading }) => {
  const handleKeyDown = React.useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  React.useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <>
    <div className="modal-backdrop fade show rg-modal-backdrop rg-modal-backdrop--seller"></div>
    <div className="modal fade text-left w-100 show rg-modal rg-modal--seller rg-modal--new-client" tabIndex="-1" style={{ display: 'block' }} aria-modal="true" role="dialog" >
    <div className="modal-dialog modal-lg modal-dialog-centered rg-modal__dialog rg-modal__dialog--lg">
        <div className="modal-content rg-modal__content">
        <div className="modal-header rg-modal__header">
            <h6 className="modal-title rg-modal__title">Cliente Nuevo</h6>
            <button type="button" className="btn-close" onClick={onClose}></button>
        </div>
        <div className="modal-body rg-modal__body">
            <div className="rg-modal__cards-grid">
                <div className="card profile-card text-center rg-client-card rg-modal__profile-card" >
                <div className="card-body pb-0">
                    <div className="avatar avatar-xl mb-3 rg-modal__avatar">
                      <span className="rg-modal__avatar-initials" aria-hidden>{getInitials(client.name, 'NC')}</span>
                    </div>
                    <h6 className="card-title text-primary rg-modal__profile-name">{client.name}</h6>
                    <p className="text-muted rg-modal__profile-meta">CUIL: {formatCUIL(client.cuit)}</p>
                    
                </div>
                <div className='card-footer border-0 m-0 pt-0 rg-modal__actions'>
                    <button className="btn btn-primary rg-modal__action-btn m-1" onClick={() => onConfirm(client)} disabled={loading} > {loading ? <span className="spinner-border spinner-border-sm" /> : 'Confirmar'} </button>
                    <button className="btn btn-secondary rg-modal__action-btn m-1" onClick={onClose}>Cancelar</button>
                </div>
                </div>
            </div>
        </div>
        </div>
    </div>
    </div>
    </>
);
};

NewClientModal.propTypes = {
  client: PropTypes.shape({
    name: PropTypes.string,
    cuit: PropTypes.string,
  }).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NewClientModal;
